export default __webpack_public_path__ + "static/media/wht-cat-2.f3daf903.svg";